export enum DraftFilters {
    YEAR = 'Year',
    ROUND = 'Round',
    TEAM = 'Team',
    LEAGUE = 'League',
    AMATEUR_TEAM = 'Amateur Team',
    COUNTRY = 'Country',
    POSITION = 'Position',
}
